import { PermissionResponse, RealmA6bEnum, Role } from '@goldcast/api/backend';

import { State } from './types';

const mutations = {
  setPermissionConfig(state: State, permissionConfig: PermissionResponse) {
    state.permissionConfig = permissionConfig;
  },
  setRolesByRealm(state: State, payload: Record<RealmA6bEnum, Array<Role>>) {
    state.rolesByRealm = payload;
  },
  setIsLoadingRoles(state: State, isLoading: boolean) {
    state.isLoadingRoles = isLoading;
  },
  appendRoleByRealm(state: State, payload: { realm: RealmA6bEnum; role: Role }) {
    if (!state.rolesByRealm[payload.realm]) {
      state.rolesByRealm[payload.realm] = [];
    }

    state.rolesByRealm[payload.realm].push(payload.role);
  },
  removeRoleByRealm(state: State, payload: { realm: RealmA6bEnum; roleId: number }) {
    if (!state.rolesByRealm[payload.realm]) {
      return;
    }

    state.rolesByRealm[payload.realm] = state.rolesByRealm[payload.realm].filter(role => role.id !== payload.roleId);
  },
  updateRoleByRealm(state: State, payload: { realm: RealmA6bEnum; role: Role }) {
    state.rolesByRealm[payload.realm] = state.rolesByRealm[payload.realm].map(role =>
      role.id === payload.role.id ? payload.role : role
    );
  }
};

export default mutations;
